import { Grid, useAppDispatch, useAppSelector } from '../../base';
import { IJob } from '../../common';
import { useEffectOnce } from 'react-use';
import { jobsActions, jobsSelectors } from '../../actions';
import {
    JobOverviewContent,
    JobRequirementsAndBenefitsContent,
} from '../JobCommonComponents';
import { ContentBox, PageWrapper } from './PositionEntity.styles';
import { LoadingPage } from '../../pages';
import { useEffect } from 'react';

const PositionEntity = ({ posotionId }: { posotionId: string }) => {
    const dispatch = useAppDispatch();

    useEffectOnce(() => {
        dispatch(
            jobsActions.fetchActiveJob({
                jobId: posotionId,
                isCandidate: true,
            })
        );
    });

    const job: IJob =
        useAppSelector(jobsSelectors.getActiveJob) || ({} as IJob);

    useEffect(() => {
        return () => {
            dispatch(
                jobsActions.setActiveJob({
                    job: {} as IJob,
                })
            );
        };
    }, [dispatch]);

    return (
        <>
            {job?.id ? (
                <PageWrapper>
                    <ContentBox>
                        <Grid container rowSpacing={4} columnSpacing={8}>
                            <Grid item xs={12} md={6}>
                                <JobOverviewContent isEmployerView={false} />
                            </Grid>
                            <Grid item xs={12} md={6}>
                                <JobRequirementsAndBenefitsContent
                                    isEmployerView={false}
                                />
                            </Grid>
                        </Grid>
                    </ContentBox>
                </PageWrapper>
            ) : (
                <LoadingPage />
            )}
        </>
    );
};

export default PositionEntity;
